import { FC } from "react"

import { buildCssClassName } from "@/3514/utils"

import Spinner from "./Spinner"

interface IProps {
    className?: string
}

const FullSpinner: FC<IProps> = ({ className }) => {
    return (
        <div
            className={buildCssClassName("w-100 h-100 d-flex justify-content-center", { [className]: className })}
            data-testid="full-spinner"
        >
            <Spinner />
        </div>
    )
}

export default FullSpinner
